import React from 'react';
import { useLangStore, useT, type Lang } from '../../i18n';

// 语言切换。不做全局悬浮: 业务页右上角都是各页自己的操作按钮 (例如压裂模拟的「运行模拟」),
// 悬浮层会把它们盖住。所以由各外壳放到固定位置 —— 登录页右上角、项目选择页头部、
// 业务页侧边栏顶部。
const OPTIONS: Array<{ value: Lang; label: string }> = [
  { value: 'zh', label: '中' },
  { value: 'en', label: 'EN' },
];

type Props = {
  /** dark: 深色侧边栏上用 */
  tone?: 'light' | 'dark';
  style?: React.CSSProperties;
};

export default function LanguageSwitch({ tone = 'light', style }: Props) {
  const { lang, setLang } = useLangStore();
  const t = useT();
  const dark = tone === 'dark';

  return (
    <div
      role="group"
      data-i18n-skip=""   // 「中 / EN」本身不参与页面翻译
      aria-label={t('切换语言')}
      title={t('切换语言')}
      style={{
        display: 'inline-flex', padding: 2, borderRadius: 12, flexShrink: 0,
        background: dark ? 'rgba(255,255,255,0.08)' : '#FFFFFF',
        border: `1px solid ${dark ? 'rgba(255,255,255,0.16)' : '#D6DAE0'}`,
        ...style,
      }}
    >
      {OPTIONS.map((o) => {
        const active = o.value === lang;
        return (
          <button
            key={o.value}
            type="button"
            aria-pressed={active}
            onClick={() => setLang(o.value)}
            style={{
              minWidth: 26, padding: '1px 7px', borderRadius: 10, border: 'none',
              fontSize: 11, fontWeight: 700, lineHeight: 1.5, cursor: 'pointer',
              fontFamily: 'inherit',
              background: active ? (dark ? '#C2533A' : '#2C3E50') : 'transparent',
              color: active ? '#FFFFFF' : dark ? '#A8B8C8' : '#4F6680',
            }}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
